module.exports = __webpack_public_path__ + "img/logo-dkm.5ffeb19e.png";